import React, { useState, useEffect } from 'react';
import { Typography, Grid, CircularProgress, Box, Button } from '@mui/material';
import { getStatsByStatus, getStatsByType } from '../services/api';
import StatsChart from '../components/Dashboard/StatsChart';
import { useNavigate } from 'react-router-dom';

function DashboardStatsPage() {
  const [statusData, setStatusData] = useState([]);
  const [typeData, setTypeData] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [statusRes, typeRes] = await Promise.all([
          getStatsByStatus(),
          getStatsByType()
        ]);
        setStatusData(statusRes.data);
        setTypeData(typeRes.data);
      } catch (error) {
        console.error("Error fetching stats data", error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  if (loading) return <CircularProgress />;

  return (
    <Box>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
        <Typography variant="h4" gutterBottom>
          Sala Situacional - Estadísticas
        </Typography>
        <Button variant="outlined" onClick={() => navigate('/dashboard')}>
          Volver a la Tabla
        </Button>
      </Box>
      <Grid container spacing={3}>
        <Grid item xs={12} md={6}>
          <StatsChart chartData={statusData} title="Solicitudes por Estatus" />
        </Grid>
        <Grid item xs={12} md={6}>
          <StatsChart chartData={typeData} title="Solicitudes por Tipo" />
        </Grid>
      </Grid>
    </Box>
  );
}

export default DashboardStatsPage;